import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../../common-imports"
import { SearchSortService } from "@app/services/search-sort.service"
import { SortThComponent } from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { FilterByPropPipe } from "@app/utils/filter-by-prop.pipe"
import { SortByPropPipe } from "@app/utils/sort-by-prop.pipe"
import { Row } from "./row"
import { NgTemplateOutlet } from "@angular/common"

@Component({
	selector: "list",
	imports: [
		COMMON_IMPORTS,
		SortThComponent,
		LangValPipe,
		FilterByPropPipe,
		SortByPropPipe,
		NgTemplateOutlet,
		Row,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<div class="sorter">
				<div style="width: 45px"></div>
				<div class="colstat-extra-small">{{ "id" | langVal }}</div>
				<ng-container
					*ngTemplateOutlet="
						sortTh;
						context: { fieldName: 'name', cls: 'colstat-big' }
					"
				/>
				<div class="colstat-small">{{ "notification_default" | langVal }}</div>
				<ng-container
					*ngTemplateOutlet="
						sortTh;
						context: { fieldName: 'latest_invite_date', cls: 'colstat-medium' }
					"
				/>
				<div class="colstat-medium">
					{{ "latest_invite_version" | langVal }}
				</div>
				<ng-container
					*ngTemplateOutlet="
						sortTh;
						context: { fieldName: 'latest_filled_date', cls: 'colstat-price' }
					"
				/>
				<div class="colstat-medium">
					{{ "latest_filled_version" | langVal }}
				</div>
				<div class="colstat-extra-small">{{ "download" | langVal }}</div>
				<div class="colstat-extra-small">{{ "pdf-view" | langVal }}</div>
				<div class="colstat-small">{{ "email_copy" | langVal }}</div>

				<div class="colstat-extra-small">{{ "fill" | langVal }}</div>
			</div>
		</div>
		<div class="card-list">
			@for (
				row of arr
					| filterByProp: "name" : search
					| sortByProp
						: sortField
						: sortIsAsc
						: (sortField === "name" ? "string" : "date");
				track row.id
			) {
				<row
					[row]="row"
					[type]="type"
					[latestVersionId]="latestVersionId"
					(onCheck)="onCheck.emit($event)"
					(filled)="filled.emit($event)"
				/>
			}
		</div>

		<ng-template
			#sortTh
			let-fieldName="fieldName"
			let-cls="cls"
		>
			<div
				[class]="cls"
				(click)="searchSortService.updateSortField(this, fieldName)"
				sorter
				[fieldName]="fieldName"
				[displayName]="fieldName | langVal"
				[sortField]="sortField"
				[sortIsAsc]="sortIsAsc"
			></div>
		</ng-template>
	`,
})
export class List {
	@Input() arr: any[] = []
	@Input() search: string = ""
	@Input() type: string = ""
	@Input() latestVersionId = null
	@Output() onCheck = new EventEmitter()
	@Output() filled = new EventEmitter()
	sortField: string = "name"
	sortIsAsc: boolean = true

	constructor(public searchSortService: SearchSortService) {}
}
